module.exports = __webpack_public_path__ + "media/assets/icons/plus-0a08d382f46999ac05e3e76686ab9526.svg";